export const formatCurrency = (value: number) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '');

export const formatCpfCnpj = (cpfCnpj: string | number, tipoPessoa: string): string => {
    let cpfCnpjStr: string = cpfCnpj ? cpfCnpj.toString().replace(/^0+/, '') : '';

    if (tipoPessoa === 'PF') {
        cpfCnpjStr = cpfCnpjStr.padStart(11, '0');

        return `${cpfCnpjStr.substring(0, 3)}.${cpfCnpjStr.substring(3, 6)}.${cpfCnpjStr.substring(6, 9)}-${cpfCnpjStr.substring(9, 11)}`;
    } else {
        cpfCnpjStr = cpfCnpjStr.padStart(14, '0');

        return `${cpfCnpjStr.substring(0, 2)}.${cpfCnpjStr.substring(2, 5)}.${cpfCnpjStr.substring(5, 8)}/${cpfCnpjStr.substring(8, 12)}-${cpfCnpjStr.substring(12, 14)}`;
    }
};